import useBreadcrumbs from "use-react-router-breadcrumbs";
import Helmet from "react-helmet";
import { useLayout } from "../../../../provider/LayoutProvider";
import { Title } from "./styles";
import { useEffect, useState } from "react";

const routes = [
  {
    path: "dashboard", // Add a leading slash to the parent path
    breadcrumb: null,
    children: [
      {
        path: "cursos", // Add a leading slash to the child path
        breadcrumb: "Cursos",
        children: [
          { path: "new", breadcrumb: "Nuevo Curso" },
          { path: "list", breadcrumb: "Cursos" },
          { path: "edit", breadcrumb: "Editar Curso" },
          { path: "preview", breadcrumb: "Curso" },
        ],
      },
      {
        path: "mis-cursos", // Add a leading slash to the child path
        breadcrumb: "Mis Cursos",
        children: [{ path: "list", breadcrumb: "Mis Cursos" }],
      },
      {
        path: "mi-perfil", // Add a leading slash to the child path
        breadcrumb: "Mi Perfil",
        children: [{ index: true, breadcrumb: "Mi Perfil" }],
      },
    ],
  },
];

const Component = () => {
  const { layout } = useLayout();
  const [title, setTitle] = useState("");
  const breadcrumbs = useBreadcrumbs(routes);

  useEffect(() => {
    const layoutTitle = layout.title;
    layoutTitle && setTitle(layout.title);

    const breadcrumb = breadcrumbs[breadcrumbs.length - 1].breadcrumb;
    !layoutTitle &&
      !!breadcrumb &&
      typeof breadcrumb !== "object" &&
      typeof breadcrumb === "string" &&
      setTitle(breadcrumb);

    const routeBreadcrumb =
      breadcrumbs[breadcrumbs.length - 1]?.match?.route?.breadcrumb;
    (!layoutTitle && !breadcrumb) ||
      (typeof breadcrumb === "object" &&
        !!routeBreadcrumb &&
        typeof routeBreadcrumb === "string" &&
        setTitle(routeBreadcrumb));
  }, [breadcrumbs]);

  if (!layout.showTitle) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>
          {`Adecco LAB - 
          ${title}`}
        </title>
      </Helmet>
      <Title>{title}</Title>
    </>
  );
};

export default Component;
